import React from 'react';
import { graphql, compose } from 'react-apollo';
import BaseWidget from '../../../../widgets/baseWidget';
import { getPrayingStatistics } from './queries/queries';
import { ByDayPrayingTimeDistribution } from '../../common/charts/byDayPrayingTimeDistribution';
import DataProcessor from '../../common/dataProcessors/prayingDataProcessor';
import PrayingWidget from '../../common/widgets/praying';
import { ErrorBoundary } from "../../../../errorBoundary/errorBoundary";

class Praying extends BaseWidget {
  get statisticsData() {
    return this.props.data.statistics.churchManager.church.weekly.praying;
  }

  get dataProcessor() {
    return new DataProcessor(this.apiData, 'week');
  }

  render() {
    return (
      <PrayingWidget data={this.dataProcessor.data} loading={this.props.data.loading} title="Weekly Praying"
                     comment={this.comment}>
        <ByDayPrayingTimeDistribution data={this.dataProcessor.chartData} pointTooltip={this.dataProcessor.pointTooltip} />
      </PrayingWidget>
    )
  }
}

export default compose(
  graphql(getPrayingStatistics,
    {
      options: {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true //e.vasilevsky TODO: make it default after updating react-apollo to the latest version
      }
    }),
  ErrorBoundary
)(Praying);



// WEBPACK FOOTER //
// ./src/components/pages/statistics/church/weekly/praying.js